export default __webpack_public_path__ + "fonts/campton-light-webfont.woff2";